// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__47-m_","left":"StickyBox_left__FYyxQ","right":"StickyBox_right__rNCfK"};